import React, { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import styles from './style.scss';

export function PhoneInputField({
  // countryCode,
  placeholder,
  handleChange,
  handleBlur,
  value,
  error,
  ...props
}) {
  const [countryCode, setCountryCode] = useState('gb');
  // Track the latest value so the async geolocation below never clobbers a
  // number that has already loaded.
  const valueRef = React.useRef(value);
  valueRef.current = value;

  useEffect(() => {
    let cancelled = false;
    const hasValue = value != null && value.toString().trim() !== '';
    // Only auto-detect the country for an EMPTY field (a brand-new entry).
    // When a value already exists, react-phone-input-2 derives the country
    // from the number itself; switching the `country` prop afterwards would
    // reset the input to just the dial code and wipe the saved number.
    if (hasValue) return;
    async function getUserCountry() {
      try {
        const response = await fetch('https://ipwho.is/');
        const data = await response.json();
        const valueArrived =
          valueRef.current != null && valueRef.current.toString().trim() !== '';
        if (!cancelled && !valueArrived && data.country_code) {
          setCountryCode(data.country_code.toLowerCase());
        }
      } catch (err) {
        console.error("IP API Error:", err);
      }
    }
    getUserCountry();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <PhoneInput
        country={countryCode}
        name={'homephone'}
        id={'homephone'}
        value={value}
        onChange={handleChange}
        containerClass={styles.borderless}
        onBlur={handleBlur}
        placeholder={placeholder}
        {...props}
      />
      <div className='error-input-container'>
        {error ? <p className='form-error'>{error}</p> : null}
      </div>
    </>
  );
}
